// extracted by mini-css-extract-plugin
export var wrapper = "style-module--wrapper---2fBz";
export var blueWrapper = "style-module--blueWrapper--Mz4a3";
export var contentWrapper = "style-module--contentWrapper--I5R9A";
export var subTitle = "style-module--subTitle--xO1j9";